import { ActivityProps } from '~/bootcamp/Activities/types/activities.types'
import { MultipleChoiceQuestion } from '~/types/bootcamp'

export interface MultipleChoiceProps extends ActivityProps {
  questions: MultipleChoiceQuestion[]
}

export interface MultipleChoiceActivityData {
  question: MultipleChoiceQuestion
  totalRightAnswer: number
  questionIndex: number
}

export enum AnswerType {
  WRONG = 'wrong',
  CORRECT = 'correct',
  SELECT_CORRECT = 'select-correct',
  SELECT_ALL_CORRECT = 'select-all-correct',
  SELECT_ONLY_CORRECT = 'select-only-correct',
}
